import { FC, PropsWithChildren, useEffect } from "react";
import { useFormikContext } from "formik";
import { CreateOrganizationFormSchema } from "../organizationOnboardingForms";

export const CreateOrganizationDataProvider: FC<PropsWithChildren> = ({
    children,
}) => {
    const {
        values: { organizationName },
        touched,
        setFieldValue,
    } = useFormikContext<CreateOrganizationFormSchema>();

    useEffect(() => {
        if (!touched.businessName) {
            setFieldValue("businessName", organizationName);
        }
    }, [organizationName, setFieldValue, touched.businessName]);

    return children;
};
